const styles = {
  item: {
    paddingTop: {
      xs: '25px',
      xl: '37px',
    },
    position: 'relative',
    '&:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3)': {
      paddingTop: 0,
    },
    '&:nth-of-type(4),&:nth-of-type(5)': {
      paddingTop: {
        xl: 0,
      },
    },
  },
  imageWrapper: (theme, IconComponent) => ({
    display: 'flex',
    color: `${theme.palette.kit.text.mainInverse}`,
    opacity: 0.3,
    height: {
      xs: '24px',
      xl: '47px',
    },
    width: '80%',
    ':hover': {
      opacity: 1,
    },
    ':focus, :active': {
      opacity: 1,
      color: `${theme.palette.kit.button.primary.active}`,
      outline: 'none',
    },
    '& > .MuiSvgIcon-root': {
      ':focus, :active': {
        outline: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '78px',
      },
      [theme.breakpoints.up('sm')]: {
        maxWidth: `${IconComponent().props.sx.width}`,
      },
      height: '100%',
      alignSelf: 'center',
      marginRight: 'auto',
      marginLeft: 'auto',
      [theme.breakpoints.down('md')]: { width: 'auto' },
    },
  }),
};

export default styles;
